import {
  select, scaleLinear,
  lineRadial, range, curveLinearClosed,
  easeQuadInOut
} from 'd3'

class D3SpiderChart {
  constructor(chartData) {
    this.colour = this.chartId === 1 ? " #4990e2" : "#26bc63";
    this.colour = "#f5894e";
    this.svgContainerRef = chartData.svgContainerRef;
    this.containerHeight = chartData.svgContainerRef.current.clientHeight
    this.containerWidth = chartData.svgContainerRef.current.clientWidth
    this.data = chartData.data
    this.svgRef = chartData.svgRef
    this.chartId = chartData.chartId
    this.r = 100;
    this.radius = 240;
    this.rScale = scaleLinear().domain([0, 10]).range([0, this.radius])
    this.dummyCircleRadius = 8;
    this.axisCircles = 2;
    this.lavels = 10;
    this.axesLength = 10;
    this.angleSlice = Math.PI * 2 / this.axesLength;
    const dummyData = [[
      { "axis": "Government Services", "value": 10, "volume": 1043 },
      { "axis": "Cocktail Bar", "value": 10, "volume": 1177 },
      { "axis": "Train Fare", "value": 10, "volume": 1447 },
      { "axis": "Hotels", "value": 10, "volume": 4384 },
      { "axis": "Business Services", "value": 10, "volume": 4631 },
      { "axis": "Food Store", "value": 10, "volume": 7743 },
      { "axis": "Store Shopping", "value": 10, "volume": 9493 },
      { "axis": "Petrol", "value": 10, "volume": 11842 },
      { "axis": "Taxi Fare", "value": 10, "volume": 11939 },
      { "axis": "Eating Out", "value": 10, "volume": 12612 }]];
    this.radarLine = lineRadial()
      .curve(curveLinearClosed)
      .radius((d, i) => {
        return this.rScale(d)
      })
      .angle((d, i) => i * this.angleSlice);

    // 
    // if (this.chartId === 1) {
    //   chartData.svgContainerRef.current.style.border = "1px solid #4990e2"
    // } else {
    //   chartData.svgContainerRef.current.style.border = "1px solid #26bc63"
    // }
    chartData.svgContainerRef.current.style.border = "1px solid #f5894e"
    this.svg = select(this.svgRef.current);
    this.svg.attr('height', this.containerHeight)
    this.svg.attr('width', this.containerWidth)
    let margin = { left: 400, top: 240, right: 300, bottom: 240 }

    if (this.containerWidth < 720) {
      // If container width is less than 720, center the diagram
      // by having the same  width and height
      // and equal margin all around
      margin = { left: 300, top: 300, right: 300, bottom: 300 }
      this.svg.attr('height', this.containerWidth)
    }

    this.svg = this.svg.attr("viewBox", `-${margin.left}, -${margin.top}, ${this.r * 2 + margin.left + margin.right}, ${this.r * 2 + margin.top + margin.bottom}`)

    this.container = this.svg.selectAll(`.container_${this.chartId}`).data([null]).join(
      enter => enter.append('g').attr("class", `container_${this.chartId}`).attr("transform", `translate(${this.r}, ${this.r}) `),
      update => update.attr("class", `container_${this.chartId}`).attr("transform", `translate(${this.r}, ${this.r}) `)
    )

    this.axisGrid = select(`.container_${this.chartId}`).selectAll('g').data([null])
      .join(enter => enter.append('g')
        .attr('class', 'axisGrid'),
        update => update.attr('class', 'axisGrid')
      )

    const axis = this.axisGrid.selectAll('.axis')
      .data(dummyData[0].map(d => d.axis))
      .join('g')
      .attr('class', 'axis')

    axis.append('line')
      .attr('x1', 0)
      .attr('y1', 0)
      .attr('x2', (d, i) => this.radius * 1 * Math.cos(this.angleSlice * i - Math.PI / 2))
      .attr('y2', (d, i) => this.radius * 1 * Math.sin(this.angleSlice * i - Math.PI / 2))
      .attr('class', 'line')
      .style('stroke', (d, i) => i === 0 ? "#828282" : '#ddd')
      .style('pointer-events', 'none')
      .style('stroke-width', '2px');
    this.axisGrid.selectAll('.axisLabel')
      .data(range(1, (this.lavels + 1)).reverse())
      .enter()
      .append('text')
      .attr('class', 'axisLabel')
      .attr('x', 4)
      .attr('y', d => -(d * this.radius / this.lavels))
      .attr('fill', '#737373')
      .attr('font-size', '12px')
      .text(d => d !== 10 ? d : "")

    this.axisGrid.selectAll('.lavels')
      .data([null])
      .join('circle')
      .attr('class', 'gridCircle')
      .attr('r', this.dummyCircleRadius)
      .style('fill', '#666666')
      .style('pointer-events', 'none')
      ;



    const plots1 = this.container.selectAll('.boundary').data(dummyData)
    plots1.join(
      enter => enter.append('path')
        .attr('class', 'boundary')
        .attr('fill', 'none')
        .attr('stroke', '#666666')
        .attr('stroke-width', 4)
        .attr('d', d => this.radarLine(d.map(v => v.value)))
    )

    const circles = this.container.selectAll('.dummy-datapoint');
    circles.data(dummyData[0]).join(
      enter => enter.append('circle')
        .call(enter => enter.transition().duration(3000))
        .attr('class', 'dummy-datapoint')
        .attr('r', this.dummyCircleRadius)
        .attr('fill', '#666666')
        .attr('cx', (d, i) => this.rScale(d.value) * Math.cos(this.angleSlice * i - Math.PI / 2))
        .attr('cy', (d, i) => this.rScale(d.value) * Math.sin(this.angleSlice * i - Math.PI / 2))
    )
  }

  updateChart(chartData, colour, ind, volume, isMobile) {
    // this.svg = select(this.svgRef.current);
    // this.svg.attr('height', "auto")
    this.svg.attr('width', this.svgContainerRef.current.clientWidth)
    let margin = { left: 400, top: 240, right: 300, bottom: 240 }
    if (this.svgContainerRef.current.clientWidth < 720) {
      // If container width is less than 720, center the diagram
      // by having the same  width and height
      // and equal margin all around
      margin = { left: 300, top: 300, right: 300, bottom: 300 }
      this.svg.attr('height', this.svgContainerRef.current.clientWidth)
    }

    this.svg = this.svg.attr("viewBox", `-${margin.left}, -${margin.top}, ${this.r * 2 + margin.left + margin.right}, ${this.r * 2 + margin.top + margin.bottom}`)

    this.container = this.svg.selectAll(`.container_${this.chartId}`).data([null]).join(
      enter => enter.append('g').attr("class", `container_${this.chartId}`).attr("transform", `translate(${this.r}, ${this.r}) `),
      update => update.attr("class", `container_${this.chartId}`).attr("transform", `translate(${this.r}, ${this.r}) `)
    )

    let _xpos = [];
    if (!chartData) return;

    // ADD CHART TITLE
    select(this.svgContainerRef.current).selectAll(`.soldo-datavis__svg-title--${this.chartId}`).data([`${ind}`.toUpperCase()]).join('h1')
      .style("position", "absolute")
      .style("top", `${isMobile ? 10 : 20}px`)
      .style("left", `${isMobile ? 10 : 20}px`)
      .attr('class', `soldo-datavis__svg-title soldo-datavis__svg-title--${this.chartId}`)
      .html(d => d.replace(/\d{1,2}\.\s/, "") + `${isMobile ? "" : "<br/>"} EXPENSES:`)
    // }

    let datum = chartData;
    // datum.sort(function (a, b) {
    //   if (a.axis < b.axis) {
    //     return -1;
    //   } else if (a.axis > b.axis) {
    //     return 1;
    //   } else {
    //     return 0;
    //   }
    // });
    let data = [datum]
    let axesDomain = data[0].map(d => d.axis);



    this.container.selectAll('.legend').data(axesDomain).join(
      enter => enter.append('text')
        .attr('class', 'legend')
        .style('font-size', '20px')

        .attr('x', (d, i) => {
          // this.append('rect')
          const xpos = this.radius * 1.15 * Math.cos(this.angleSlice * i - Math.PI / 2);
          _xpos.push({ pos: xpos, label: d });
          return xpos;
        })
        .attr('y', (d, i) => this.radius * 1.15 * Math.sin(this.angleSlice * i - Math.PI / 2)),
      update => update
        .attr('x', (d, i) => {
          // this.append('rect')
          const xpos = this.radius * 1.15 * Math.cos(this.angleSlice * i - Math.PI / 2);
          _xpos.push({ pos: xpos, label: d });
          return xpos;
        })

    )
    this.container.selectAll('.text').data(_xpos)
      .join('text')

      // enter => enter.append("text")
      .attr('class', 'text legend')
      .style('text-anchor', (d, i) => {
        if (i === 0 || i === 5) {
          return 'middle'
        } else if (i < 5) {
          return 'start'
        } else {
          return 'end'
        }
      })
      .attr('x', (d, i) => this.radius * 1.15 * Math.cos(this.angleSlice * i - Math.PI / 2))
      .attr('y', (d, i) => this.radius * 1.15 * Math.sin(this.angleSlice * i - Math.PI / 2))
      .each(function (d, i) {
        select(this).selectAll('.axis-legend').data(d => d.label.split(" ")).join('tspan')
          .attr('class', 'axis-legend')
          .attr("x", d.pos)
          .attr("dy", (d, i) => `${i * 1.2}em`)
          .style('fill', colour)
          .text(d => d)
      })

    let tooltip = document.getElementById("TnC-chart__tooltip");

    let plots = this.container.selectAll('.plots').data(data)
    plots.join('path')
      .attr('class', 'plots')
      .attr('fill', colour)
      .attr('fill-opacity', 0.3)
      .attr('stroke', colour)
      .attr('stroke-width', 4)
      // .on('mousemove', (e, d) => {
      //   e.target.setAttribute('fill-opacity', 0.5)
      //   let posX = e.offsetX > 312 ? (e.x + 40) + "px" : (e.x) + 'px';
      //   tooltip.innerHTML = `<span style="font-size: 1.1em">${ind} Industry </span><br/> <span style="font-size: 1.2em">Total transactions: ${volume} </span>`;
      //   tooltip.style.left = posX;
      //   tooltip.style.border = `2px solid ${colour}`
      //   tooltip.style.top = e.y - 60 + 'px';
      //   tooltip.style.position = "fixed";
      //   tooltip.style.display = "block";
      //   tooltip.style.opacity = 1;
      // })
      // .on('mouseout', (e, d) => {
      //   e.target.setAttribute('fill-opacity', 0.3)
      //   tooltip.style.opacity = 0;
      // })
      .transition().ease(easeQuadInOut).duration(500)
      .attr('d', d => this.radarLine(d.map(v => v.value)))



    const circles = this.container.selectAll('.datapoint');
    circles.data(data[0]).join(
      enter => enter.append('g').append('circle')
        .attr('class', 'datapoint')
        .attr('r', 8)
        .attr('fill', colour)
        .style('opacity', 0)
        .on('mousemove', function (e, d) {
          const pos = this.getBoundingClientRect()
          e.target.setAttribute('r', 10)
          // let posX = e.offsetX > 312 ? (e.x + 10) + "px" : (e.x+10) + 'px';

          tooltip.innerHTML = `${((parseInt(d.volume) / d.totalVolume) * 100).toFixed(2)}% transactions`;
          tooltip.style.left = (pos.x + 18) + "px";
          tooltip.style.border = `2px solid ${colour}`
          tooltip.style.top = `${pos.y - 25}px`;
          tooltip.style.position = "fixed";
          tooltip.style.display = "block";
          tooltip.style.opacity = 1;
        })
        .on('mouseout', (e, d) => {
          e.target.setAttribute('r', 8)
          tooltip.style.opacity = 0;
        })

      ,
      update => update
    )
      .transition().ease(easeQuadInOut).duration(500)
      .attr('cx', (d, i) => this.rScale(d.value) * Math.cos(this.angleSlice * i - Math.PI / 2))
      .attr('cy', (d, i) => this.rScale(d.value) * Math.sin(this.angleSlice * i - Math.PI / 2))
      .style('opacity', 1)

    select(window).on('touchmove', (d) => { tooltip.style.opacity = 0; })
      .on('scroll', (d) => { tooltip.style.opacity = 0; })
      .on('wheel', (d) => { tooltip.style.opacity = 0; })
  }

}

export default D3SpiderChart;